import {
    Box,
    Divider,
    Stack,
    Typography,
    Button,
} from '@mui/material'
import { Image } from 'antd'
import FooterBannerImage from '../../assets/footer-banner.webp'
import FooterPhone from '../../assets/new-footer/footer_phone.png'
import FooterLocation from '../../assets/new-footer/footer_location.png'
import FooterTime from '../../assets/new-footer/footer_time.png'
import MerchantLogin from '../../assets/new-footer/footer_merchant_login.png'
import CustomerLogin from '../../assets/new-footer/footer_customer_login.png'
import AppGallery from '../../assets/download/download_appgallery.png'
import AppStore from '../../assets/download/download_appstore.png'
import GooglePlay from '../../assets/download/download_googleplay.png'
import ShareInstagram from '../../assets/new-footer/share_instagram.png'
import ShareFaceBook from '../../assets/new-footer/share_facebook.png'
import ShareYoutune from '../../assets/new-footer/share_youtube.png'
import Logo from '../../assets/download/logo_icon.png'
import { PORTOAL_LOGIN_LINK, ROOT_PATH, MERCHANT_LOGIN_LINK, FACEBOOK_LINK, YOUTUBE_LINK, INSTAGRAM_LINK, GOOGLE_PLAY_STORE_LINK, APP_STORE_LINK, APP_GALLERY_LINK } from '../../common/config'
import { useTranslation } from 'react-i18next'

export const NewFooter: React.FC = () => {

    const { t } = useTranslation()

    // 打开product
    const openProduct = () => {
        window.open(ROOT_PATH + '/product')
    }
    // 打开faq
    const openFaq = () => {
        window.open(ROOT_PATH + '/faq')
    }
    // 打开how to pay
    const openHowToPay = () => {
        window.open(ROOT_PATH + '/repayment-channel')
    }

    // 打开contact us
    const openContactUs = () => {
        window.open(ROOT_PATH + '/contact-us')
    }

    // merchat login
    const clickMerchantLogin = () => {
        window.open(MERCHANT_LOGIN_LINK)
    }

    // Portal login
    const clickPortalLogin = () => {
        window.open(PORTOAL_LOGIN_LINK)
    }

    // 打开privacy
    const openPrivacyPolicy = () => {
        window.open(ROOT_PATH + '/privacy')
    }

    // 打开terms&conditions
    const openTermsAndConditions = () => {
        window.open(ROOT_PATH + '/terms-conditions')
    }

    // 打开facebook
    const clickFacebook = () => {
        window.open(FACEBOOK_LINK)
    }

    // 打开youbube
    const clickYoutube = () => {
        window.open(YOUTUBE_LINK)
    }

    // 打开ins
    const clickIns = () => {
        window.open(INSTAGRAM_LINK)
    }

    // ======================= GooglePlay
    const clickGooglePlay = () => {
        window.open(GOOGLE_PLAY_STORE_LINK)
    }

    // ======================= AppStore
    const clickAppStore = () => {
        window.open(APP_STORE_LINK)
    }

    // ======================= AppGallery
    const clickAppGallery = () => {
        window.open(APP_GALLERY_LINK)
    }

    // ======================= RENDER FUNCTIONS

    const renderCopyrightSection = () => (
        <Box
            height={112}
            sx={{ display: 'flex', }}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    width: '100%',
                    margin: '0',
                    paddingLeft: '72px',
                    paddingRight: '72px',
                }}>
                <Typography fontSize={16} fontWeight={400} color="#6B6B6B" textAlign="center">
                    {t('t93')}
                </Typography>
                <Stack direction="row" spacing={3} alignSelf="center" alignItems={'center'}>
                    <Button
                        onClick={openPrivacyPolicy}
                        sx={{
                    
                            textDecoration: 'none',
                            cursor: 'pointer',
                            textTransform: 'none',
                            padding: '0px',
                            alignContent: 'start',
                            justifyContent: 'start',
                            alignItems: 'center',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }}>
                        <Typography fontSize={16} fontWeight={700}
                            color={{
                                lg: '#6B6B6B',
                                xs: '#6B6B6B',
                            }}>{t('t94')}</Typography>
                    </Button>
                    <Button 
                        onClick={openTermsAndConditions}
                        sx={{
                   
                            textDecoration: 'none',
                            cursor: 'pointer',
                            textTransform: 'none',
                            padding: '0px',
                            alignContent: 'start',
                            justifyContent: 'start',
                            alignItems: 'center',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }} >
                        <Typography fontSize={16} fontWeight={700} color={{ lg: '#6B6B6B', xs: '#6B6B6B', }}>
                            {t('t95')}</Typography>
                    </Button>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
                        <Button onClick={clickFacebook} sx={{
                            width: 32,
                            height: 32,
                            minWidth: 32,
                            padding: '0px',
                            margin: '0px',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }}>
                            <Image src={ShareFaceBook} width={32} height={32} alt='' preview={false}></Image>
                        </Button>
                        <Box sx={{ width: '10px' }}></Box>
                        <Button variant="primary" onClick={clickYoutube} sx={{
                            width: 32,
                            height: 32,
                            minWidth: 32,
                            padding: '0px',
                            margin: '0px',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }}>
                            <Image src={ShareYoutune} width={32} height={32} alt='' preview={false}></Image>
                        </Button>
                        <Box sx={{ width: '10px' }}></Box>
                        <Button onClick={clickIns} sx={{
                            width: 32,
                            height: 32,
                            minWidth: 32,
                            padding: '0px',
                            margin: '0px',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }}>
                            <Image src={ShareInstagram} width={32} height={32} alt='' preview={false}></Image>
                        </Button>

                    </Box>

                </Stack>
            </Stack>
        </Box>
    )

    // ======================= VIEWS
    return (
        <Stack>
            <Box
                component="footer"
                bgcolor="#FFFDF7"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundImage: `url(${FooterBannerImage})`,
                    backgroundBlendMode: 'overlay',
                }}
            >

                <Box
                    sx={{
                        width: '100%',
                        backgroundColor: '#FFFDF7',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}
                >
                    {/* SHENMA Credit Sdn Bhd */}
                    <Box sx={{
                        width: '46%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: '72px',
                        paddingTop: '100px',
                    }}>
                        <Typography variant="body1" fontSize={20} fontWeight={600} color={'#141F39'}>
                            SHENMA Credit Sdn Bhd  <span className="smallStyle">(201401009329 / 1085407-K)</span>
                        </Typography>
 
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'top',
                            paddingTop: '24px',
                        }}>
                            <Image src={FooterLocation} width={24} height={24} alt='' preview={false}></Image>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'top'
                            }}>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    2, Jalan Muthu Palaniappan,
                                </Typography>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    14000 Bukit Mertajam, Penang
                                </Typography>
                            </Box>
                        </Box>

                        
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            paddingTop: '12px',
                        }}>
                            <Image src={FooterPhone} width={24} height={24} alt='' preview={false}></Image>
                            <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                04-5230033
                            </Typography>
                        </Box>
                        
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'top',
                            paddingTop: '12px',
                        }}>
                            <Image src={FooterTime} width={24} height={24} alt='' preview={false}></Image>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'top'
                            }}>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    {t('t81')}
                                </Typography>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    {t('t82')}
                                </Typography>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    {t('t83')}
                                </Typography>
                            </Box>
                        </Box>
                      
                    </Box>

                    {/* Products & Services */}
                    <Box sx={{
                        width: '34%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: '160px',
                        paddingTop: '100px',
                    }}>
                        <Typography variant="body1" fontSize={20} fontWeight={600} color={'#141F39'}>
                            {t('t84')}
                        </Typography>
                        
                        <Button onClick={openProduct}
                            sx={{
                                width: '180px',
                                marginTop: '24px',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textTransform: 'none',
                                padding: '0px',
                                alignContent: 'start',
                                justifyContent: 'start',
                                alignItems: 'start',
                                '&:hover': {
                                    bgcolor: '#FFFDF7',
                                },
                            }}
                        >
                            <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                {t('t84')}
                            </Typography>
                        </Button>
                        
                        <Button onClick={openFaq}
                            sx={{
                                width: '160px',
                                marginTop: '12px',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textTransform: 'none',
                                padding: '0px',
                                alignContent: 'start',
                                justifyContent: 'start',
                                alignItems: 'start',
                                '&:hover': {
                                    bgcolor: '#FFFDF7',
                                },
                            }}
                        >
                            <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                {t('t85')}
                            </Typography>
                        </Button>
                        

                        
                        <Button onClick={openHowToPay}
                            sx={{
                                width: '160px',
                                marginTop: '12px',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textTransform: 'none',
                                padding: '0px',
                                alignContent: 'start',
                                justifyContent: 'start',
                                alignItems: 'start',
                                '&:hover': {
                                    bgcolor: '#FFFDF7',
                                },
                            }}
                        >
                            <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                {t('t86')}
                            </Typography>
                        </Button>
                        
                        <Button onClick={openContactUs}
                            sx={{
                                width: '160px',
                                marginTop: '12px',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                textTransform: 'none',
                                padding: '0px',
                                alignContent: 'start',
                                justifyContent: 'start',
                                alignItems: 'center',
                                '&:hover': {
                                    bgcolor: '#FFFDF7',
                                },
                            }}
                        >
                            <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                {t('t87')}
                            </Typography>
                        </Button>
                    </Box>

                    {/* Online Service */}
                    <Box sx={{
                        width: '20%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: '0px',
                        paddingTop: '100px',
                    }}>
                        <Typography variant="body1" fontSize={20} fontWeight={600} color={'#141F39'}>
                            {t('t88')}
                        </Typography>


                        <Button onClick={clickMerchantLogin} sx={{
                            padding: '0px',
                            alignContent: 'start',
                            justifyContent: 'start',
                            textTransform: 'none',
                            alignItems: 'center',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                paddingTop: '24px',
                            }}>
                                <Image src={MerchantLogin} width={24} height={24} alt='' preview={false}></Image>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    {t('t89')}
                                </Typography>
                            </Box>

                        </Button>

                        <Button onClick={clickPortalLogin} sx={{
                            padding: '0px',
                            alignContent: 'start',
                            justifyContent: 'start',
                            textTransform: 'none',
                            alignItems: 'center',
                            '&:hover': {
                                bgcolor: '#FFFDF7',
                            },
                        }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                paddingTop: '12px',
                            }}>
                                <Image src={CustomerLogin} width={24} height={24} alt='' preview={false}></Image>
                                <Typography variant="body1" fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingLeft={'5px'}>
                                    {t('t90')}
                                </Typography>
                            </Box>
                        </Button>
                    </Box>
                </Box>

                {/* SHENMA Mobile */}
                <Box sx={{
                    width: '100%',
                    backgroundColor: '#FFFDF7',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    paddingLeft: '72px',
                    paddingTop: '40px',
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}>
                        <Image src={Logo} width={50} height={50} alt='' preview={false}></Image>
                        <Box sx={{paddingLeft: '8px', width: '400px' }}>
                            <Typography fontSize={20} fontWeight={600} color={'#141F39'}>
                                {t('t91')}<br />
                                {t('t92')}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '20px',
                        paddingBottom: '40px',
                    }}>
                        <Box onClick={clickGooglePlay} sx={{
                            cursor: 'pointer',
                        }}>
                            <Image src={GooglePlay} width={133} height={40} alt='' preview={false}></Image>
                        </Box>
                        <Box onClick={clickAppStore} sx={{
                            paddingLeft: '8px',
                            cursor: 'pointer',
                        }}>
                            <Image src={AppStore} width={133} height={40} alt='' preview={false}></Image>
                        </Box>
                        <Box onClick={clickAppGallery} sx={{
                            paddingLeft: '8px',
                            cursor: 'pointer',
                        }}>
                            <Image src={AppGallery} width={133} height={40} alt='' preview={false}></Image>
                        </Box>
                    </Box>
                </Box>

                <Box sx={{
                    paddingLeft: '72px',
                    paddingRight: '72px',
                }}>
                    <Divider sx={{ background: 'rgba(57, 33, 245, 0.15)' }} />
                </Box>
                {renderCopyrightSection()}
            </Box>
        </Stack>
    )
}

// ======================= EXPORT
export default NewFooter
